import React, { useState } from "react";
import { copy } from "../../lib/format";

export function CopyBtn({ text, testId }) {
  const [done, setDone] = useState(false);
  return (
    <button
      data-testid={testId}
      onClick={() => { copy(text); setDone(true); setTimeout(() => setDone(false), 1200); }}
      className="ml-2 text-[11px]"
      style={{ color: done ? "var(--green)" : "var(--muted-2)" }}
      title="Copy"
    >
      <i className={`fa-solid ${done ? "fa-check" : "fa-copy"}`} />
    </button>
  );
}

export function Row({ label, children, mono = false }) {
  return (
    <div className="flex flex-col md:flex-row md:items-start gap-1 md:gap-4 px-5 py-3.5" style={{ borderBottom: "1px solid rgba(30,40,49,0.55)" }}>
      <div className="md:w-56 shrink-0 eyebrow pt-0.5">{label}</div>
      <div className={`flex-1 break-all text-[13.5px] ${mono ? "mono" : ""}`} style={{ color: "var(--text)" }}>{children}</div>
    </div>
  );
}
